import { RootState } from '..'

import _find from 'lodash/find'

export const getExternalViewByCombinationId = (state: RootState, combinationId: string) => {
  return _find(state.external.entries, entry => entry.combinationId === combinationId)
}
